export default __webpack_public_path__ + "static/media/verified-tag.ee547c17.svg";